import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/temporary-storage-solutions.jpg'),
    alt: 'temporary storage solutions page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'temporary storage solutions page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Temporary <span>Storage</span><span>Solutions</span>',
  description:
    'Need temporary storage solutions? Our flexible solutions offer secure space for moves, renovations, or transitions—no long-term commitments needed.',
  image: {
    url: '/images/v2/pages/landing-pages/temporary-storage-solutions/hero-image.jpg',
    alt: 'Temporary Storage Solutions'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Find Temporary Storage Near You' }
}

export const ourProcessSectionContent = {
  title: 'How Temporary Storage Solutions Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/temporary-storage-solutions/how-temporary-storage-solutions-work.png',
    alt: 'How Temporary Storage Solutions Work'
  },

  articles: [
    {
      id: 1,
      title: 'Short-Term Storage Flexibility',
      description:
        'Our temporary storage options are designed to give you the flexibility to store your items for a few days, weeks, or months, depending on your needs.',
      image: {
        src: '/images/v2/pages/landing-pages/temporary-storage-solutions/short-term-storage-flexibility.png',
        alt: 'Short-Term Storage Flexibility'
      }
    },
    {
      id: 2,
      title: 'Convenient Access',
      description:
        'You can access your stored items during regular hours, making it easy to retrieve or add more as your plans evolve.',
      image: {
        src: '/images/v2/pages/landing-pages/temporary-storage-solutions/convenient-access.png',
        alt: 'Convenient Access'
      }
    },
    {
      id: 3,
      title: 'Safe and Secure',
      description:
        'We offer climate-controlled and secure facilities with 24/7 surveillance to ensure that your belongings remain safe during their stay.',
      image: {
        src: '/images/v2/pages/landing-pages/temporary-storage-solutions/safe-and-secure.png',
        alt: 'Safe and Secure'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Secure Temporary Storage Services',
  description:
    "Temporary storage solutions are ideal for people who need extra space for a short period. Whether you're in transition, moving homes, or need temporary space while renovating, our flexible storage options give you the peace of mind and convenience you need.",
  image: {
    src: '/images/v2/pages/landing-pages/temporary-storage-solutions/secure-temporary-storage-services.jpg',
    alt: 'Secure Temporary Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Temporary Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'No Long-Term Commitment',
      description: 'Store your items for only as long as you need, with no long-term contracts or expensive fees.',
      image: {
        src: '/images/v2/pages/common/no-ong-term-commitment.png',
        alt: 'No Long-Term Commitment'
      }
    },
    {
      id: 2,
      title: 'Flexible Duration',
      description: 'Whether you need a few days or several months, we provide storage that fits your schedule.',
      image: {
        src: '/images/v2/pages/common/reduced-downtime.png',
        alt: 'Flexible Duration'
      }
    },
    {
      id: 3,
      title: 'Security and Peace of Mind',
      description:
        "Your items are safe and secure in our monitored facilities, ensuring they remain in excellent condition until you're ready for them.",
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Security and Peace of Mind'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use Temporary Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'People Moving',
          description: 'Store your belongings temporarily while you transition from one home to another.'
        },
        {
          id: 2,
          title: 'Homeowners Renovating',
          description:
            'Need space during your renovation? Our temporary storage options provide a safe place for your items while work is being done.'
        },
        {
          id: 3,
          title: 'College Students',
          description: 'Store your belongings during the summer break or between terms without any hassle.'
        },
        {
          id: 4,
          title: 'Small Business Owners',
          description:
            'Store inventory, office supplies, or seasonal equipment without worrying about long-term storage costs'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/temporary-storage-solutions/who-should-use-temporary-storage-solutions.jpg',
        alt: 'Who Should Use Temporary Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our Temporary Storage Services',

  cards: [
    {
      id: 1,
      title: 'Personal Storage Solutions',
      description: 'Keep your personal belongings secure during a move, renovation, or while traveling.',
      image: {
        src: '/images/v2/pages/common/residential-storage-services.png',
        alt: 'Personal Storage Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Climate-Controlled Storage',
      description:
        'Protect sensitive items like electronics, artwork, or antiques with our climate-controlled temporary storage units.',
      image: {
        src: '/images/v2/pages/common/climate-controlled-storage.png',
        alt: 'Climate-Controlled Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Business Storage Options',
      description: 'Store business-related items such as documents, inventory, or equipment on a short-term basis.',
      image: {
        src: '/images/v2/pages/common/business-storage-solution.png',
        alt: 'Business Storage Options'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Short-Term Rental Solutions',
      description: 'Flexible rental options for when you need temporary storage during a specific event or time frame.',
      image: {
        src: '/images/v2/pages/common/short-term-rental-solutions.png',
        alt: 'Short-Term Rental Solutions'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for Temporary Storage Solutions?',

  image: {
    url: '/images/v2/pages/landing-pages/temporary-storage-solutions/why-choose-us-for-temporary-storage-solutions.jpg',
    alt: 'Why Choose Us for Temporary Storage Solutions?'
  },

  articles: [
    {
      id: 1,
      title: 'Flexible Rental Options',
      description:
        'Rent a unit for any duration that suits your situation, allowing you to adjust your storage needs as they evolve.'
    },
    {
      id: 2,
      title: 'Easy Accessibility',
      description:
        'Our strategically located storage locations allow you to conveniently access your items whenever necessary.'
    },
    {
      id: 3,
      title: 'Enhanced Security Features',
      description:
        'Our storage facilities are equipped with state-of-the-art security systems and climate controls to ensure your belongings remain safe.'
    },
    {
      id: 4,
      title: 'Variety of Unit Sizes',
      description:
        "Choose from a range of unit sizes to find the perfect fit for your belongings, whether you're storing a few boxes or larger items."
    },
    {
      id: 5,
      title: 'Transparent Pricing',
      description:
        'We offer competitive rates for short-term storage without any hidden fees, making budgeting easier for you.'
    },
    {
      id: 6,
      title: 'Customer-Centric Support',
      description:
        'Enjoy exceptional customer service with our friendly staff, who are always ready to assist you with your storage needs.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Temporary Storage Solutions Available For Short-Term Needs',
  description:
    'Temporary storage solutions available for short-term needs. Fast and secure storage services for your temporary items.',
  image: {
    src: '/images/v2/pages/landing-pages/temporary-storage-solutions/temporary-storage-solutions-available-for-short-term-needs.png',
    alt: 'Temporary Storage Solutions Available For Short-Term Needs'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Get Temporary Storage Today' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Storage Partners',
  description: 'We work with industry-leading partners to offer secure, temporary storage solutions at great rates.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx collaborates with us to offer timely delivery and pickup for your temporary storage needs, ensuring smooth and efficient transitions.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL provides global solutions for temporary storage, allowing you to ship your items securely from one location to another while storing them temporarily.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS offers convenient, short-term storage and shipping solutions that are tailored to meet your temporary storage needs with fast and reliable service.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
